"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var cryptoJs = require("crypto-js");
var util_1 = require("util");
var CreateMerrcoTransaction = /** @class */ (function () {
    function CreateMerrcoTransaction(transaction, device) {
        this.CustomerNumber = '00000000';
        this.Amount = 0;
        this.InvoiceNumber = '000000000000';
        this.InputType = 'N';
        this.CardType = ' ';
        this.CardNumber = '';
        this.ExpirationDate = '';
        this.LanguageCode = 'E';
        this.CurrencyCode = 'CAD';
        this.OperatorID = '00000001';
        // Turn negative amounts to positive as merrcoTransactions are only positive
        if (transaction.amount) {
            this.Amount = Math.abs(transaction.amount);
        }
        var merrcoMerchantNumber = device.merrcoMerchantNumber, merrcoMerchantTerminalNumber = device.merrcoMerchantTerminalNumber, merrcoCompanyNumber = device.merrcoCompanyNumber, deviceId = device.id;
        this.deviceId = deviceId;
        if (!merrcoMerchantNumber) {
            throw new Error('Merchant Number is required');
        }
        if (!merrcoMerchantTerminalNumber) {
            throw new Error('Merchant Terminal Number is required');
        }
        if (!merrcoCompanyNumber) {
            throw new Error('Merrco Company Number is required');
        }
        this.MerchantNumber = merrcoMerchantNumber;
        this.MerchantTerminalNumber = merrcoMerchantTerminalNumber;
        this.CompanyNumber = merrcoCompanyNumber;
        var invoiceNumber = Math.floor(Math.random() * 100000000000) + 100000000000;
        this.InvoiceNumber = this.convertItemToLength(invoiceNumber, 12);
    }
    CreateMerrcoTransaction.prototype.convertItemToLength = function (amount, length) {
        var amountStr = typeof amount === 'number' ? amount.toString() : amount;
        var amountLength = amountStr.length;
        var baseLengthString = new Array(length + 1).join('0');
        var transAmount = baseLengthString.substr(0, baseLengthString.length - amountLength) + amountStr;
        return transAmount;
    };
    Object.defineProperty(CreateMerrcoTransaction.prototype, "commonRequestPayloadObject", {
        get: function () {
            return {
                CompanyNumber: this.convertItemToLength(this.CompanyNumber, 5),
                MerchantNumber: this.MerchantNumber.toString(),
                Amount: this.convertItemToLength(this.Amount, 11),
                InvoiceNumber: this.InvoiceNumber,
                MerchantTerminalNumber: this.MerchantTerminalNumber.toString(),
                LanguageCode: this.LanguageCode,
                OperatorID: this.OperatorID,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateMerrcoTransaction.prototype, "requestPayload", {
        get: function () {
            var payload = __assign({}, this.commonRequestPayloadObject, { CustomerNumber: this.CustomerNumber, OriginalInvoiceNumber: '000000000000', InputType: this.InputType, CardType: this.CardType, CardNumber: this.CardNumber, ExpirationDate: this.ExpirationDate, CvvCvc2Number: '', CurrencyCode: this.CurrencyCode });
            return jsonToQueryString(payload);
        },
        enumerable: true,
        configurable: true
    });
    CreateMerrcoTransaction.prototype.encryptedRecoveryRequestPayload = function (originalTransactionNumber) {
        return base64Encryption(jsonToQueryString({
            CompanyNumber: this.convertItemToLength(this.CompanyNumber, 5),
            MerchantNumber: this.MerchantNumber.toString(),
            CustomerNumber: this.CustomerNumber,
            OriginalTransactionNumber: originalTransactionNumber,
        }));
    };
    Object.defineProperty(CreateMerrcoTransaction.prototype, "encryptedPurchaseRequestPayload", {
        get: function () {
            return base64Encryption(this.requestPayload);
        },
        enumerable: true,
        configurable: true
    });
    return CreateMerrcoTransaction;
}());
exports.CreateMerrcoTransaction = CreateMerrcoTransaction;
var MerrcoTransactionStatus;
(function (MerrcoTransactionStatus) {
    MerrcoTransactionStatus["PROCESSING"] = "processing";
    MerrcoTransactionStatus["COMPLETED"] = "completed";
    MerrcoTransactionStatus["FAILED"] = "failed";
})(MerrcoTransactionStatus = exports.MerrcoTransactionStatus || (exports.MerrcoTransactionStatus = {}));
function parseMerrcoTransactionStatus(merrcoTransactionResponse) {
    var trimmedReturnCode = merrcoTransactionResponse.returnCode.trim();
    switch (trimmedReturnCode) {
        case '00':
            return MerrcoTransactionStatus.COMPLETED;
        case 'P6': // Transaction cancelled on pinpad
        case '04':
        default:
            return MerrcoTransactionStatus.FAILED;
    }
}
exports.parseMerrcoTransactionStatus = parseMerrcoTransactionStatus;
function parseMerrcoTransactionResponse(merrcoTransactionResponse) {
    // return codes: https://www.ct-paiement.com/wiki/en:gateway:home:webservices:rclist
    var updateMerrcoTransaction = {
        status: parseMerrcoTransactionStatus(merrcoTransactionResponse),
        responsePayload: JSON.stringify(merrcoTransactionResponse),
    };
    return updateMerrcoTransaction;
}
exports.parseMerrcoTransactionResponse = parseMerrcoTransactionResponse;
function base64Encryption(request) {
    var wordArray = cryptoJs.enc.Utf8.parse(request);
    var base64 = cryptoJs.enc.Base64.stringify(wordArray);
    return base64;
}
exports.base64Encryption = base64Encryption;
/**
 * Convert object to json
 * @param json
 */
function jsonToQueryString(json) {
    return Object.keys(json).filter(function (key) { return json[key] !== undefined; }).map(function (key) {
        if (util_1.isArray(json[key])) {
            return encodeURIComponent(key) + "=" + JSON.stringify(json[key]);
        }
        return encodeURIComponent(key) + "=" + json[key];
    }).join('&');
}
exports.jsonToQueryString = jsonToQueryString;
//# sourceMappingURL=Merrco.js.map